import React from "react"
import useIsMobile from "@/shared/use_is_mobile"
import VenueFooterDesktop from "./desktop"
import VenueFooterMobile from "./mobile"

const VenueFooter: React.FC = () => {
  const isMobile = useIsMobile()
  return isMobile ? <VenueFooterMobile /> : <VenueFooterDesktop />
}

export default VenueFooter
